// src/data/screensData.js - Contains all screen product data

export const screensData = [
  {
    id: "echomap-73sv-uhd2",
    name: "ECHOMAP UHD2 73sv",
    screenSize: "7",
    viewOnPhone: "No",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 849.99,
    resolution: "800 x 480",
    powerDraw12V: "1.52",
    image: "/images/screens/garmin-echomap-uhd2-73sv.jpg",
    description: "7-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Great mid-range option with touchscreen.",
    productLink: "https://at.fish/EchomapUHD2-73sv"
  },
  {
    id: "echomap-93sv-uhd2",
    name: "ECHOMAP UHD2 93sv",
    screenSize: "9",
    viewOnPhone: "No",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 1099.99,
    resolution: "1024 x 600",
    powerDraw12V: "1.72",
    image: "/images/screens/garmin-echomap-uhd2-93sv.jpg",
    description: "9-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Great mid-range option with touchscreen.",
    productLink: "https://at.fish/EchomapUHD2-93sv"
  },
  {
    id: "echomap-ultra-2-106sv",
    name: "ECHOMAP Ultra 2 106sv",
    screenSize: "10",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "2",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 1899.99,
    resolution: "1280 x 800",
    powerDraw12V: "2.3",
    image: "/images/screens/garmin-echomap-ultra2-106sv.jpg",
    description: "10-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Premium features with excellent screen clarity.",
    productLink: "https://at.fish/echomap-ultra-2-106sv"
  },
  {
    id: "echomap-ultra-2-126sv",
    name: "ECHOMAP Ultra 2 126sv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "2",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 2699.99,
    resolution: "1280 x 800",
    powerDraw12V: "2.5",
    image: "/images/screens/garmin-echomap-ultra2-126sv.jpg",
    description: "12-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Large screen with premium features.",
    productLink: "https://at.fish/echomap-ultra-2-126sv"
  },
  {
    id: "gpsmap-8610xsv",
    name: "GPSMAP 8610xsv",
    screenSize: "10",
    viewOnPhone: "Yes",
    hdmiOut: "Yes",
    hdmiIn: "Yes",
    networkPorts: "2",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 2799.99,
    resolution: "1920 x 1200",
    powerDraw12V: "1.5",
    image: "/images/screens/garmin-gpsmap-8610xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+8610xsv",
    productLink: "https://at.fish/gpsmap-8610xsv"
  },
  {
    id: "gpsmap-8612xsv",
    name: "GPSMAP 8612xsv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "Yes",
    hdmiIn: "Yes",
    networkPorts: "2",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 4099.99,
    resolution: "1920 x 1080",
    powerDraw12V: "1.3",
    image: "/images/screens/garmin-gpsmap-8612xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+8612xsv",
    productLink: "https://at.fish/gpsmap-8612xsv"
  },
  {
    id: "gpsmap-943xsv",
    name: "GPSMAP 943xsv",
    screenSize: "9",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 1499.99,
    resolution: "1280 x 720",
    powerDraw12V: "1.37",
    image: "/images/screens/garmin-gpsmap-943xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+943xsv",
    productLink: "https://at.fish/gpsmap-943xsv"
  },
  {
    id: "gpsmap-1243xsv",
    name: "GPSMAP 1243xsv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "Yes",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 2999.99,
    resolution: "1280 x 800",
    powerDraw12V: "1.68",
    image: "/images/screens/garmin-gpsmap-1243xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+1243xsv",
    productLink: "https://at.fish/gpsmap-1243xsv"
  },
  {
    id: "gpsmap-1042xsv",
    name: "GPSMAP 1042xsv",
    screenSize: "10",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Keypad",
    msrp: 1599.99,
    resolution: "1280 x 800",
    powerDraw12V: "1.9",
    image: "/images/screens/garmin-gpsmap-1042xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+1042xsv",
    productLink: "https://at.fish/gpsmap-1042xsv"
  },
  {
    id: "gpsmap-1242xsv",
    name: "GPSMAP 1242xsv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Keypad",
    msrp: 2299.99,
    resolution: "1280 x 800",
    powerDraw12V: "2.2",
    image: "/images/screens/garmin-gpsmap-1242xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+1242xsv",
    productLink: "https://at.fish/gpsmap-1242xsv"
  }
]; 